var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"col-span-6 w-full",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.video[0].url,"type":_vm.video[0].contentType}})])}
var staticRenderFns = []

export { render, staticRenderFns }